import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5455 10H5.45455C4.65122 10 4 10.6888 4 11.5385V20.4615C4 21.3112 4.65122 22 5.45455 22H18.5455C19.3488 22 20 21.3112 20 20.4615V11.5385C20 10.6888 19.3488 10 18.5455 10Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 10V8.03922C6 6.43752 6.63214 4.90142 7.75736 3.76885C8.88258 2.63627 10.4087 2 12 2C13.5913 2 15.1174 2.63627 16.2426 3.76885C17.3679 4.90142 18 6.43752 18 8.03922V10",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 16.75C11.9005 16.75 11.8052 16.7105 11.7348 16.6402C11.6645 16.5698 11.625 16.4745 11.625 16.375C11.625 16.2755 11.6645 16.1802 11.7348 16.1098C11.8052 16.0395 11.9005 16 12 16",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 16.75C12.0995 16.75 12.1948 16.7105 12.2652 16.6402C12.3355 16.5698 12.375 16.4745 12.375 16.375C12.375 16.2755 12.3355 16.1802 12.2652 16.1098C12.1948 16.0395 12.0995 16 12 16",
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
export { SvgLock as ReactComponent };
